import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // chartjs-ror is a gem. It returns canvas and script which is executing by
    // normal page loading. But in case with hotwire id does not execute. We need to do this.
    eval($(this.element).find('script').html())
  }
}
